import clsx from 'clsx';
import React, { FC, PropsWithChildren, Ref } from 'react';

import styles from './styles.module.css';

interface Props {
  className?: string;
  ref: Ref<HTMLDivElement>;
}

const EmblaSlider: FC<PropsWithChildren<Props>> = ({ children, className, ref }) => {
  return (
    <div className={clsx(styles.embla, className)} ref={ref}>
      {children}
    </div>
  );
};

export default EmblaSlider;
